import React, { useEffect, useState } from 'react';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import ExecutiveProjectReport, { SEVERITY_META } from '../../../Director/ExecutiveProjectReport';
import api from '../../../../utils/functions/api';

const API = `${process.env.REACT_APP_API_URL}/ai-followup`;

// กล่อง "สรุปจาก AI" ในหน้า T-1: สรุปล่าสุด + ประเด็นที่ติดตามอยู่ + ปุ่มเปิดรายงานผู้บริหารของโครงการ
// ไม่มีข้อมูลจากระบบ AI (โครงการนอกขอบเขตติดตาม/ระบบปิด) = ไม่แสดงอะไรเลย
export function AiSummaryBox({ projectId }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!projectId) return undefined;
    let alive = true;
    api.get(`${API}/project-report/${projectId}`)
      .then((res) => alive && setData(res.data))
      .catch(() => alive && setData(null));
    return () => {
      alive = false;
    };
  }, [projectId]);

  if (!data?.metrics) return null;
  const a = data.analysis;

  return (
    <Box sx={{ mt: 1.5, p: 1, border: '1px solid #c4b5fd', borderRadius: 1.5, bgcolor: '#faf5ff', flexShrink: 0 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.5 }}>
        <Chip size="small" label="สรุปจาก AI" sx={{ bgcolor: '#ede9fe', color: '#5b21b6', fontWeight: 700 }} />
        <Button size="small" variant="outlined" onClick={() => setOpen(true)} sx={{ fontSize: '0.7rem', py: 0.2, minWidth: 0 }}>
          รายงานผู้บริหาร
        </Button>
      </Stack>
      <Typography variant="body2" sx={{
          fontSize: '0.78rem',
          color: a?.summary ? 'text.primary' : 'text.disabled',
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}>
        {a?.summary || 'ยังไม่มีผลวิเคราะห์จาก AI ของโครงการนี้'}
      </Typography>
      {data.issues.length > 0 && (
        <Stack spacing={0.25} sx={{ mt: 0.5 }}>
          {data.issues.slice(0, 3).map((i) => {
            const sev = SEVERITY_META[i.severity] || SEVERITY_META.info;
            return (
              <Typography key={i.id} variant="caption" sx={{ color: sev.color, fontWeight: 600 }}>
                {`• ${i.title}`}
              </Typography>
            );
          })}
          {data.issues.length > 3 && (
            <Typography variant="caption" color="text.secondary">{`และอีก ${data.issues.length - 3} ประเด็น`}</Typography>
          )}
        </Stack>
      )}
      <ExecutiveProjectReport projectId={projectId} open={open} onClose={() => setOpen(false)} />
    </Box>
  );
}

export default AiSummaryBox;
